export function generateApiUrlByVersion(version: number) {
  const baseUrl = `${process.env.REACT_APP_ARO_API_URL}/api/v1` || 'http://localhost/api/v1'
  return baseUrl.replace(/\/v1[/]?/s, `/v${version}`)
}
